import { AxiosResponse } from 'axios';
import { axiosAuthInstance } from '../../instance.ts';
import { IJobCategory, IJobInfrastructure, IJobSkill } from './types.ts';

const CommonAPI = {
  getJobCategories: (): Promise<AxiosResponse<IJobCategory[], void>> =>
    axiosAuthInstance.get('/common/job-categories/'),

  getJobInfrastructures: (): Promise<AxiosResponse<IJobInfrastructure[], void>> =>
    axiosAuthInstance.get('/common/job-infrastructures/'),

  getJobSkills: (): Promise<AxiosResponse<IJobSkill[], void>> =>
    axiosAuthInstance.get('/common/job-skills/'),
};

export default CommonAPI;
